<template>
  <div class="mt-md-0 mt-2">
    <div class="details-title">{{ title }}</div>
    <div class="card card-body card-account bg-light">
      <div class="row">
        <div class="col-md-8">
          {{ accountData.email }}
        </div>
        <div class="col-md-5 text-right">
          <div @click="$bvModal.show('login-details-modal')" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal ref="login-details-modal" id="login-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-13">
                <label for="email" class="col-form-label">E-mailadres</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  class="form-control"
                  :class="{'is-invalid': $v.email.$error}"
                  v-model="email"
                  @blur="$v.email.$touch()"
                  placeholder="E-mailadres"
                >
                <span v-if="$v.email.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. uw e-mailadres in.</strong>
                </span>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-13">
                <label for="password" class="col-form-label">Bevestig wachtwoord</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  class="form-control"
                  :class="{'is-invalid': $v.password.$error}"
                  v-model="password"
                  @blur="$v.password.$touch()"
                >
                <span v-if="$v.password.$error" class="invalid-feedback" role="alert">
                  <strong>Uw wachtwoord is verplicht</strong>
                </span>
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="loginDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': loginDetailsStatus.success, 'alert-danger': !loginDetailsStatus.success }"
        >
          <strong>{{ loginDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">{{ title }} opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="loginDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { email, minLength, required } from 'vuelidate/lib/validators'

  import { MUTATE_LOGIN_DETAILS_STATUS, SAVE_LOGIN_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Inloggegevens',
        email: this.accountData.email,
        password: ''
      }
    },
    validations: {
      email: {
        required,
        email,
        minLen: minLength(5)
      },
      password: {
        required
      }
    },
    computed: {
      loginDetailsStatus() {
        return this.$store.getters.loginDetailsStatus
      },
      loginDetailsBusy() {
        return this.$store.getters.loginDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['login-details-modal'].hide()
        // discard changes
        this.email = this.accountData.email
        this.password = ''
      },
      saveDetails() {
        const formData = {
          email: this.email,
          password: this.password
        }
        this.$store.dispatch(SAVE_LOGIN_DETAILS, formData).then(() => {
          if (this.loginDetailsStatus.success) {
            this.$refs['login-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_LOGIN_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
